'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_auth$package$AppAuthError$() {
}
export { $c_Lapp_data_auth$package$AppAuthError$ as $c_Lapp_data_auth$package$AppAuthError$ };
$p = $c_Lapp_data_auth$package$AppAuthError$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_auth$package$AppAuthError$;
/** @constructor */
function $h_Lapp_data_auth$package$AppAuthError$() {
}
export { $h_Lapp_data_auth$package$AppAuthError$ as $h_Lapp_data_auth$package$AppAuthError$ };
$h_Lapp_data_auth$package$AppAuthError$.prototype = $p;
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeString__validate__T__O(this, input);
});
var $d_Lapp_data_auth$package$AppAuthError$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_auth$package$AppAuthError$, "app.data.auth$package$AppAuthError$", ({
  Fu: 1,
  B: 1,
  C: 1,
  J: 1
}));
export { $d_Lapp_data_auth$package$AppAuthError$ as $d_Lapp_data_auth$package$AppAuthError$ };
var $n_Lapp_data_auth$package$AppAuthError$;
function $m_Lapp_data_auth$package$AppAuthError$() {
  if ((!$n_Lapp_data_auth$package$AppAuthError$)) {
    $n_Lapp_data_auth$package$AppAuthError$ = new $c_Lapp_data_auth$package$AppAuthError$();
  }
  return $n_Lapp_data_auth$package$AppAuthError$;
}
export { $m_Lapp_data_auth$package$AppAuthError$ as $m_Lapp_data_auth$package$AppAuthError$ };
//# sourceMappingURL=app.data.auth$package$-App-Auth-Error$.js.map
